import React, { useRef, useEffect, useState } from "react";
import jspreadsheet from "jspreadsheet-ce";
import { getRandomString } from "../../helpers";

export default function ExcelContainer({
  data,
  columns,
  dimensions = [36, 10],
  pagination = 10,
}) {
  const [id, setId] = useState(getRandomString());
  const jRef = useRef(null);
  const options = {
    data: data,
    minDimensions: dimensions,
    editable: true,
    allowInsertColumn: false,
    search: false,
    pagination: pagination,
    columns: columns,
    onchange: function (instance, cell, c, r, value) {
      if (c == 12) {
        var columnName = jspreadsheet.getColumnNameFromId([c - 1, r]);
        value = [];
        instance.jexcel.setValue(columnName, value);
      }
    },
  };

  useEffect(() => {
    if (!jRef.current.jspreadsheet) {
      jspreadsheet(jRef.current, options);
    }
  }, [options]);

  useEffect(() => {
    setId(getRandomString());
  }, [data]);

  return (
    <div>
      <div key={id} ref={jRef} />
    </div>
  );
}
